import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import theme from '../../Theming/DefaultTheme';
import Grid from '@mui/material/Grid2';
import { DEFAULT_MAP_ZOOM, MAP_SECTION_HEIGHT, RADIUS_SELECT_OPTIONS, } from '../../../constants';
import PlaceInfoMenu from './PlaceInfoWindow';
import { AppConfig } from '../../../app.config';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import GooglePlaceSelector from '../inputs/GooglePlaceSelector';
import { useJsApiLoader } from '@react-google-maps/api';
import { useEffect, useState } from 'react';
import SelectInput from '../inputs/SelectInput';
import { AdvancedMarker, APIProvider, Map, InfoWindow, Pin, ControlPosition, MapControl, } from '@vis.gl/react-google-maps';
import GooglePlaceSelectorPanel from '../inputs/GooglePlaceSelectorPanel';
var mapStyles = {
    backgroundColor: theme.palette.grey[500],
    height: MAP_SECTION_HEIGHT,
    width: '100%',
    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
};
var MapCard = function (_a) {
    var userLocation = _a.userLocation, selectedPlace = _a.selectedPlace, selectedPlaces = _a.selectedPlaces, searchRadius = _a.searchRadius, searchInputDisabled = _a.searchInputDisabled, onPlaceSelected = _a.onPlaceSelected, onPlaceAdded = _a.onPlaceAdded, onClearSelectedPlace = _a.onClearSelectedPlace, onPlaceInfoWindowClose = _a.onPlaceInfoWindowClose, onRadiusChange = _a.onRadiusChange;
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    var _b = useState(false), mobileSearchPanelOpen = _b[0], setMobileSearchPanelOpen = _b[1];
    var _c = useState(userLocation), mapCenter = _c[0], setMapCenter = _c[1];
    var isLoaded = useJsApiLoader({
        googleMapsApiKey: AppConfig.googleApiKey,
    }).isLoaded;
    useEffect(function () {
        if (userLocation) {
            setMapCenter(userLocation);
        }
    }, [userLocation]);
    var handleMobileSearchPanelOpen = function () {
        setMobileSearchPanelOpen(true);
    };
    var handleMobileSearchPanelClose = function () {
        setMobileSearchPanelOpen(false);
    };
    var clearMapCenter = function () {
        if (mapCenter)
            setMapCenter(undefined);
    };
    var getMapElements = function () {
        var mapElements = [];
        // Add markers for the user's current location
        if (userLocation) {
            mapElements.push(_jsx(AdvancedMarker, { title: 'Your Location', position: { lat: userLocation.lat, lng: userLocation.lng }, draggable: false, children: _jsx(Pin, { background: theme.palette.primary.main, borderColor: theme.palette.primary.main, glyphColor: theme.palette.primary.extraLight }) }, 'user-location-marker'));
        }
        // Add markers for all selected places
        selectedPlaces.forEach(function (place, index) {
            mapElements.push(_jsx(AdvancedMarker, { title: place.name, draggable: false, position: {
                    lat: place.lat,
                    lng: place.lng,
                } }, "selected-location-".concat(index, "-").concat(place.id)));
        });
        // Add a pin for the current selected place
        if (selectedPlace) {
            // Add an info window for the current selected place
            mapElements.push(_jsx(InfoWindow, { onCloseClick: onPlaceInfoWindowClose, disableAutoPan: false, position: {
                    lat: selectedPlace.lat,
                    lng: selectedPlace.lng,
                }, children: _jsx(PlaceInfoMenu, { place: selectedPlace }) }, 'selected-place-info-window'));
        }
        return mapElements;
    };
    return (_jsxs(APIProvider, { apiKey: AppConfig.googleApiKey, children: [isLoaded == true ? (_jsx(Box, { style: { width: '100%' }, children: _jsxs(Grid, { container: true, spacing: 0, children: [_jsx(Grid, { size: { lg: 8, xs: 12 }, children: _jsxs(Map, { disableDefaultUI: true, style: mapStyles, mapId: AppConfig.googleMapId, center: mapCenter, defaultZoom: DEFAULT_MAP_ZOOM, gestureHandling: 'cooperative', onCenterChanged: clearMapCenter, children: [_jsx(MapControl, { position: ControlPosition.LEFT_TOP, children: _jsx(Box, { style: { width: 180, margin: 5 }, children: _jsx(SelectInput, { label: 'Radius', options: RADIUS_SELECT_OPTIONS, isClearable: false, isSearchable: false, placeholderText: 'Radius', disabled: false, isLoading: false, currentValue: searchRadius, handleChange: onRadiusChange }) }) }), isMobile && (_jsx(MapControl, { position: ControlPosition.LEFT_TOP, children: _jsx(Box, { style: { width: 180, margin: 5 }, children: _jsx(Button, { variant: 'contained', color: 'primary', onClick: handleMobileSearchPanelOpen, children: "Search Places" }) }) })), getMapElements()] }) }), !isMobile && (_jsx(Grid, { size: { lg: 4, xs: 12 }, children: _jsx(GooglePlaceSelector, { inputDisabled: searchInputDisabled, userLocation: userLocation, searchRadius: searchRadius.value, onPlaceSelected: onPlaceSelected, onPlaceAdded: onPlaceAdded, onClear: onClearSelectedPlace }) }))] }) })) : (_jsx(Box, { style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: MAP_SECTION_HEIGHT,
                }, children: _jsx(Typography, { variant: 'h6', children: "Loading map data..." }) })), isMobile && (_jsx(GooglePlaceSelectorPanel, { inputDisabled: searchInputDisabled, searchRadius: searchRadius.value, userLocation: userLocation, isOpen: mobileSearchPanelOpen, onPlaceSelected: onPlaceSelected, onPlaceAdded: onPlaceAdded, onClear: onClearSelectedPlace, onClose: handleMobileSearchPanelClose }))] }));
};
export default MapCard;
